<!-- 无偿资料 -->
<template>
  <div class="wrap">

    <div class="header">
      <img src="@/assets/return.png" class="return-img" @click="back()" alt="">
      <p class="header-title">无偿投稿资料</p>
    </div>

    <div class="upload-wrap" v-if="percentage === 0 && urlTemp.length === 0">
      <van-uploader class="upload-box" :after-read="afterRead" :accept="INFORMATION_UPLOAD_FILE_TYPE">
        <div class="upload-box">
          支持上传WORD/PDF/压缩文件
          <span>上传文件</span>
        </div>
      </van-uploader>
    </div>


    <div class="free-articles-wrap" v-else>
      <img :src="fileIcon" class="free-articles-icon" alt="">
      <div class="free-articles-sidebar" v-if="percentage < 100">
        <div class="free-articles-row-between">
          <div class="free-articles-right">正在上传...</div>
        </div>
        <van-progress
            :color="'#0054F7'"
            class="progress-bar-box"
            :percentage="percentage"
            :show-pivot="false"
        />
      </div>
      <div class="free-articles-sidebar" v-else>
        <div class="free-articles-row-between">
          <div class="free-articles-left">
            {{ params.fileName }}
          </div>
          <van-uploader v-if="urlTemp.length > 0" :after-read="afterRead" accept="*">
            <div class="free-articles-right">
              <img src="@/assets/icon-153.png" alt="">重新上传
            </div>
          </van-uploader>
        </div>
      </div>
    </div>

    <div class="textarea-wrap">
      <van-field
          class="textarea"
          v-model="params.title"
          rows="2"
          autosize type="textarea"
          maxlength="80"
          placeholder="给文章起个标题吧(必填)"
          show-word-limit
      />
    </div>

    <tags-edit v-model="params.label"/>

    <div class="fooer">
      <div class="bottom-row">
        <a href="javascript:void(0)" @click="selected = !selected">
          <img src="@/assets/circle-active.png" v-if="selected" class="circle-img" alt="">
          <img src="@/assets/circle.png" v-else class="circle-img" alt="">
        </a>
        我已阅读并同意
        <span class="blue" @click="$router.push('/agreement?configKey=original_pact')">《GYXQCDZ原创公约》</span>
      </div>

      <div class="btn-box">
        <button type="button" class="active" @click="submit()">去投稿</button>
      </div>
    </div>


    <!-- 确定放弃投稿弹窗 -->
    <van-overlay :show="windowAbandonSubmission" @click="windowAbandonSubmission = false" z-index="99999">
      <div class="window">
        <span class="window-text">确定放弃投稿</span>
        <div class="window-btn-box">
          <button type="button" class="cancel">取消</button>
          <button type="button" class="confirm" @click="$router.back()">确定</button>
        </div>
      </div>
    </van-overlay>

  </div>
</template>

<script>
import {
  getFileIcon,
  getFileType,
  validatorFun
} from "@/common/util";
import {
  Dialog,
  Toast
} from "vant";
import {
  DatumService,
  uploadFile,
} from "@/common/service";
import {
  INFORMATION_UPLOAD_FILE_TYPE
} from "@/common/config";
import TagsEdit from "@/components/tags-edit.vue";

export default {
  components: {TagsEdit},
  data() {
    return {
      INFORMATION_UPLOAD_FILE_TYPE,
      selected: true,

      tagMaxSize: 10,
      tagTemp: '',

      urlTemp: '',
      percentage: 0,

      params: {
        fileName: '',
        datum_url: '', // 资料地址
        title: '', // 标题
        label: [], // 资料标签id(多个用逗号隔开)
        desc: '', // 简介
      },
      validatorParams: [
        ['datum_url', ['notNull', '请上传文件']],
        ['title', ['notNull', '请输入标题']],
        ['label', [label => label.length > 0, '请添加标签']],
        // ['desc', ['notNull', '请输入简介']],
      ],
      windowAbandonSubmission: false,
      DRAFT_KEY: 'information-release-form'
    };
  },
  computed: {
    fileIcon() {
      return getFileIcon(getFileType(this.params.fileName || ''));
    },
  },
  mounted() {
    this.init();
    window.addEventListener('unload', () => this.saveInput());
  },
  destroyed() {
    window.removeEventListener('unload', () => this.saveInput());
  },
  methods: {
    back() {
      this.saveInput().then(() => {
        this.windowAbandonSubmission = true;
      });
    },
    init() {
      const option = this.$route.query;
      const id = parseInt(option.id || 0);
      if (id > 0) {
        DatumService.getUserDatumDetail({id}).then(({data}) => {
          const {id, title, desc, label_name = [], datum_url} = data.detail;
          this.params = {id, title, desc, datum_url, fileName: title + getFileType(datum_url), label: label_name};
          this.urlTemp = this.params.datum_url;
          this.percentage = 100;
        });
      } else {
        const paramsStr = localStorage.getItem(this.DRAFT_KEY);
        if (paramsStr) {
          Dialog.confirm({
            message: '发现有未提交的草稿，是否加载？',
          }).then(() => {
            try {
              this.params = JSON.parse(paramsStr);
              if (this.params.datum_url.length > 0) {
                this.urlTemp = this.params.datum_url;
                this.percentage = 100;
              }
            } catch (e) {
            }
          });
        }
        localStorage.removeItem(this.DRAFT_KEY);
      }
    },

    submit() {
      if (!this.selected) {
        return Toast('请阅读并同意《GYXQCDZ原创公约》');
      }
      const {fileName, ...params} = this.params;
      const errList = validatorFun(params, this.validatorParams);
      if (errList.length > 0) {
        return Toast(errList[0].errMsg);
      }
      DatumService.userReferDatum({
        ...params,
        label: params.label.join(',')
      }).then(({msg}) => {
        Toast(msg);
        this.params = {
          datum_url: '', // 视频地址
          title: '', // 标题
          label: [], // 视频标签id(多个用逗号隔开)
          desc: '', // 简介
        };
        setTimeout(() => {
          if (params.id > 0) {
            this.$router.back();
          } else {
            this.$router.replace('/informationmy-my-release');
          }
        }, 1500);
      });
    },

    afterRead({file, content}) {
      // 此时可以自行将文件上传至服务器
      this.urlTemp = content;
      this.params.fileName = file.name;
      uploadFile(file, ({loaded, total}) => {
        this.percentage = Math.min(parseFloat((loaded / total * 100).toFixed(2)), 99);
      }).then(({data}) => {
        this.urlTemp = data;
        this.params.datum_url = data;
        this.percentage = 100;
        console.log(this.params);
      }).catch(() => {
        this.urlTemp = '';
        this.params.datum_url = '';
        this.params.fileName = '';
        this.percentage = 0;
      });
    },

    saveInput(showDialog = false) {
      return new Promise((resolve) => {
        const params = this.params;
        const errList = validatorFun(params, this.validatorParams);
        if (!params.id && errList.length < this.validatorParams.length) {
          if (showDialog) {
            Dialog.confirm({
              title: '是否保存草稿？',
              confirmButtonColor: '#2A63F3',
              confirmButtonText: '保存草稿',
              cancelButtonText: '不保存',
            }).then(() => {
              localStorage.setItem(this.DRAFT_KEY, JSON.stringify(params));
              return resolve(true);
            }).catch(() => {
              return resolve(false);
            });
          } else {
            localStorage.setItem(this.DRAFT_KEY, JSON.stringify(params));
            return resolve(true);
          }
        } else {
          return resolve(false);
        }
      });
    },
  }
}
</script>

<style scoped>
.wrap {
  min-height: 100vh;
  background-color: #fff;
}

.wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 44px 15px 15px;
  box-sizing: border-box;
}

/* 头部样式 */
.header {
  width: 100%;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #FFFFFF;
  z-index: 999;
}

.return-img {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translate(0, -50%);
  width: 20px;
}

.header-title {
  color: #333333;
  font-size: 18px;
  font-weight:bold;
}

.upload-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background-color: #F3F3F3;
  margin: 10px 0;
}

.upload-box {
  width: 100%;
  height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #666666;
  font-size: 13px;
}

.upload-box > img {
  width: 30px;
  margin-bottom: 10px;
}

.upload-box > span {
  color: #2A63F3;
  font-size: 14px;
  width: 100px;
  height: 38px;
  border: 1px solid #2A63F3;
  border-radius: 4px;
  background-color: #F3F3F3;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 11px;
}

.video-box video {
  width: 100%;
}

.re-upload img {
  width: 30px;
  margin-bottom: 4px;
}

.textarea-wrap {
  width: 100%;
  min-height: 97px;
  display: flex;
  flex-direction: column;
  background-color: #FFFFFF;
  border-bottom: 1px solid #F3F3F3;
  margin-bottom: 14px;
  padding: 14px 0 12px;
  box-sizing: border-box;
}

.textarea {
  width: 100%;
  border: none;
  resize: none;
  font-size: 16px;
  padding: 0;
  color: #F0C78A;
}

>>> .van-field__control {
  font-size: 16px;
  color: blue !important;
}

>>> .van-field__control::placeholder {
  color: #7F7F7F;
}

.bottom-row {
  width: 100%;
  display: flex;
  align-items: center;
  color: #9C9C9C;
  font-size: 12px;
  padding: 0 6px;
  box-sizing: border-box;
}

.circle-img {
  width: 12px;
  margin-right: 6px;
}

.blue {
  color: #2A63F3;
}

.btn-box {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0 34px;
}

.btn-box > button {
  width: 100%;
  height: 44px;
  line-height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFFFFF;
  font-size: 18px;
  font-weight:bold;
  border-radius: 100px;
  background-color: #8AABFF;
}

.btn-box > button.active {
  background-color: #2A63F3;
}

.free-articles-wrap {
  width: 100%;
  display: flex;
  align-items: center;
  background-color: #F3F3F3;
  padding: 14px 8px 16px 11px;
  box-sizing: border-box;
  border-radius: 8px;
  margin: 10px 0;
}

.free-articles-icon {
  width: 26px;
  margin-right: 10px;
}

.free-articles-sidebar {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.free-articles-row-between {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.free-articles-left {
  display: flex;
  align-items: center;
  color: #333333;
  font-size: 14px;
}

.free-articles-left > img {
  width: 16px;
  margin-right: 2px;
}

.free-articles-right {
  display: flex;
  align-items: center;
  color: #0054F7;
  font-size: 12px;
}

.free-articles-right > img {
  width: 16px;
  margin-right: 2px;
}

.progress-bar-box {
  margin-top: 13px;
}

.fooer {
  width: 100%;
  display: flex;
  flex-direction: column;
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 0 12px;
  box-sizing: border-box;
}

.window {
  width: calc(100% - 54px);
  height: 180px;
  border-radius: 12px;
  background-color: #FFFFFF;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 38px 25px 32px;
  box-sizing: border-box;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}

.window-text {
  color: #222222;
  font-size: 18px;
}

.window-btn-box {
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 43px;
}

.window-btn-box > button {
  flex: 1;
  height: 42px;
  font-size: 17px;
  margin-right: 27px;
  border-radius: 50px;
}

.window-btn-box > button:last-child {
  margin-right: 0;
}

.window-btn-box > button.cancel {
  background-color: #F4F4F4;
  color: #333333;
}

.window-btn-box > button.confirm {
  background-color: #2A63F3;
  color: #FFFFFF;
}
</style>
